if (!customElements.get('tab-component')) {
  class TabComponent extends HTMLElement {
    constructor () {
      super()
      this.tabs = this.querySelectorAll('[data-tab]')
      this.tabContent = this.querySelectorAll('[data-tab-content]')
      this.bindEvents()
    }

    bindEvents () {
      this.tabs.forEach(tab => tab.addEventListener('click', this.handleTabClick.bind(this)))
    }

    handleTabClick (event) {
      const tab = event.currentTarget
      const tabId = tab.dataset.tab
      const tabContentCurrent = this.querySelectorAll(`[data-tab-content="${tabId}"]`)

      this.tabs.forEach(tab => tab.classList.remove('is-Active'))
      tab.classList.add('is-Active')

      this.tabContent.forEach(tabContent => tabContent.classList.remove('is-Active'))
      tabContentCurrent.forEach(tabContent => tabContent.classList.add('is-Active'))
    }
  }

  customElements.define('tab-component', TabComponent)
}
